// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {useMemo} from 'react';
import {bd_countries} from 'hola_opt';
// @ts-ignore
import {list} from 'zcountry';

const reg2name = (reg: string)=>{
    return reg == 'Northern America' ? 'North America'
        : reg == 'South America' ? 'Latin America'
        : reg;
};

const get_location_url = (name: string)=>{
    const slug = name == 'United Kingdom'
        ? 'great-britain'
        : name.toLowerCase().replace(' ', '-');
    return `/proxy-location/${slug}`;
};

export const use_region_countries = (region: string, limit?: number)=>{
    if (region == 'Popular')
    {
        const popular_codes = ['us', 'br', 'in', 'mx', 'de', 'fr', 'gb'];
        const data = popular_codes.map(code=>({
            name: list[code.toUpperCase()],
            count: bd_countries[code],
            to: get_location_url(list[code.toUpperCase()]),
        }))
        .sort((a, b)=>b.count - a.count)
        .slice(0, popular_codes.length)
        .map(v=>({...v, to: get_location_url(v.name)}));
        return {
            name: 'Most Popular',
            count: bd_countries.by_region['All'].count,
            data,
            to: '/proxy-location',
        };
    }
    const {count, countries} = bd_countries.by_region[region];
    const data = useMemo(()=>{
        return countries.map(c=>({
            name: list[c.toUpperCase()],
            count: bd_countries[c],
        }))
        .sort((a, b)=>b.count - a.count).slice(0, limit || countries.length)
        .map(v=>({...v, to: get_location_url(v.name)}));
    }, []);
    const reg_name = reg2name(region);
    const reg_url = get_location_url(reg_name);
    return {name: reg_name, count, data, to: reg_url};
};
